var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.condition ? 'NavigationLink' : 'span',_vm._g(_vm._b({tag:"component",attrs:{"to":_vm.condition ? _vm.to : undefined}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }